import _ from 'underscore';

export default class OrderArrivals {
  constructor($scope, OrderService, OrderBookingNoteService) {
    $scope.tabs = [
      {
        title: 'All',
        items: []
      },
      {
        title: 'Need Attention',
        items: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.get_orders = function() {
      $scope.loading = true;
      OrderService.get_arrivals_data($scope.filter).then(function(data) {
        $scope.tabs[0].items = data.booking_notes[0];
        $scope.tabs[1].items = data.booking_notes[1];
        $scope.loading = false;
      });
    };

    $scope.check_items = function(tab) {
      _.each($scope.tabs[tab].items, function(i) {
        i.checked = $scope.tabs[tab].checked;
      });
    };

    $scope.mass_update_status = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.mass_updating_status = true;
        OrderBookingNoteService.mass_update_delivery_status(_.pluck(items, 'id')).success(function(data) {
          if (data.success) {
            $scope.mass_updating_status = false;
            $scope.tabs[tab].checked = false;
            $scope.get_orders();
          }
        });
      }
    };

    $scope.init = function() {
      $scope.filter = {
        user_id: window.mode.user_id,
        is_buyer: window.mode.is_buyer
      };
      $scope.selected_tab = 0;
      $scope.get_orders();
    };

    $scope.init();
  }
}

OrderArrivals.$inject = ['$scope', 'OrderService', 'OrderBookingNoteService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-arrivals.ctrl.js